import { Account, AuthenticationError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAuthenticationRequestFailure(): boolean {
      return getState().request.isFailure;
    },
    isAuthenticationRequestPending(): boolean {
      return getState().request.isPending;
    },
    isAuthenticationRequestSuccess(): boolean {
      return getState().request.isSuccessful;
    },
    getAccount(): Account {
      return getState().account;
    },
    hasSession(): boolean {
      return getState().hasSession;
    },
    hasRetrievedSession(): boolean {
      return getState().request.isSuccessful || getState().request.isFailure;
    },
    getAuthenticationError(): AuthenticationError {
      return getState().error;
    },
  };
}

export { createSelector };
